<sc-flex vertical stretchContent fitHeight>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <sc-scroll-pane>
        <app-transport-documents-list [transportId]="transportId"
          [forceReloadRequest]="forceRefreshSubject"></app-transport-documents-list>
      </sc-scroll-pane>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <sc-flex [centered]="true">
      <!-- <app-transport-photo-button [transportId]="transportId"
                (onDocumentUploaded)="refreshDocuments()"></app-transport-photo-button> -->
      <ac-resource-upload (uploaded)="refreshDocuments()" usage="transport-document" [metaData]="{ 'TransportIdentity' : { id: transportId} }" iconClass="fa-camera"></ac-resource-upload>
    </sc-flex>
  </div>
</sc-flex>
